import apiClient from './client';

export const getSchoolProfile = async () => {
  const response = await apiClient.get('/schools/profile');
  return response.data;
};

export const updateSchoolProfile = async (formData) => {
  const response = await apiClient.put('/schools/profile', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};